import {RepositoryFactory} from '@/app/repositories/repository-factory.js';
import Repository from '@/app/repositories/repository'

const shoppingCartRepository = RepositoryFactory.get('shoppingCart');

export default Object.assign(shoppingCartRepository, {
    getByUserId : function(userId){
        return Repository.get(`${this.resource}/getByUser?userId=${userId}`);
    },
    isAlreadyInCart : function(userId, productId){
        return Repository.get(`${this.resource}/hasByUserAndProductId?userId=${userId}&productId=${productId}`);
    },
    deleteByUserId : function(userId){
        return Repository.delete(`${this.resource}/deleteByUser`, { UserFk: userId });
    }
});

// export default Object.assign(shoppingCartRepository);